import {
  Button,
  makeStyles,
  createStyles,
  Theme,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Grid
} from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { ProductSubscription } from "../../../api/Product/ProductSubscriptionApi";

const QuoteRemoveDialog = ({ open, addon, subscription, onRemove, onClose, onRemoveSubscription }: Props) => {
  const classes = useStyles();
  const handleRemove = async () => {
    handleClose();
    if (addon && onRemove) {
      await onRemove(addon);
    }

    if (subscription && onRemoveSubscription) {
      await onRemoveSubscription(subscription);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="md">
        <DialogTitle disableTypography>
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box p={4}>
            <Box>
              <img width="140px" className={classes.image} alt="delete" src="/store/images/delete_image.png" />
            </Box>
            <Box mt={3} mb={3} textAlign="center">
              Are you sure you want to remove this product from your quote?
            </Box>
            <Grid container direction="row" spacing={3} justifyContent="space-evenly">
              <Grid item md={3} xs={6}>
                <Button onClick={handleRemove} color="primary" variant="contained" fullWidth>
                  Remove
                </Button>
              </Grid>
              <Grid item md={3} xs={6}>
                <Box textAlign="right">
                  <Button onClick={handleClose} color="secondary" variant="contained" type="submit" fullWidth>
                    Keep
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default QuoteRemoveDialog;

interface Props {
  className?: string;
  open: boolean;
  addon?: QuoteLineItem | null;
  subscription?: ProductSubscription | null;
  onRemove: Function;
  onRemoveSubscription?: Function;
  onClose: Function;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    image: {
      margin: "0 auto",
      display: "block",
      maxHeight: "200px"
    }
  })
);
